import React, { useState } from 'react';
import { arrayOf, shape, string, bool, number } from 'prop-types';
import { FaqAccordion } from './faq.styles';
import JsonLD, { faqSchema } from '../../atoms/JsonLD';

const Faq = ({
  faq,
  initialOpen,
  maxQuestions,
  showMoreQuestions,
  showLessQuestions,
  questionAs
}) => {
  const [data, setData] = useState(faq.map(item => Object.assign({}, item, {
    isOpen: initialOpen
  })));
  const [maxItems, setMaxItems] = useState(maxQuestions);

  const toggleShow = i => {
    setData(prev => prev.map((item, index) => i === index ? Object.assign({}, item, {
      isOpen: !item.isOpen
    }) : item));
  };

  const showMore = () => {
    setMaxItems(faq.length);
  };

  const showLess = () => {
    setMaxItems(maxQuestions);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, data.map((item, index) => /*#__PURE__*/React.createElement(FaqAccordion, {
    "data-testid": 'item-question',
    display: index >= maxItems ? 'none' : 'block',
    key: `faq-accordion-${index}`,
    title: item.question,
    asTitle: questionAs,
    open: item.isOpen,
    onClick: () => {
      toggleShow(index);
    },
    openIcon: "ChevronRight",
    closeIcon: "ChevronUp"
  }, item.answer)), showMoreQuestions && maxItems < data.length && /*#__PURE__*/React.createElement(FaqAccordion, {
    "data-testid": "show-more",
    title: showMoreQuestions,
    open: false,
    onClick: showMore,
    openIcon: "ChevronDown",
    closeIcon: "ChevronDown",
    fontWeight: "100"
  }), showLessQuestions && maxItems === data.length && /*#__PURE__*/React.createElement(FaqAccordion, {
    "data-testid": "show-less",
    title: showLessQuestions,
    open: false,
    onClick: showLess,
    openIcon: "ChevronUp",
    closeIcon: "ChevronUp",
    fontWeight: "100"
  }), /*#__PURE__*/React.createElement(JsonLD, {
    schema: faqSchema(data),
    type: "FAQPage"
  }));
};

Faq.defaultProps = {
  questionAs: 'h3',
  faq: [],
  initialOpen: false,
  maxQuestions: undefined,
  showLessQuestions: '',
  showMoreQuestions: ''
};
process.env.NODE_ENV !== "production" ? Faq.propTypes = {
  questionAs: string,
  faq: arrayOf(shape({
    answer: string,
    question: string
  })),
  initialOpen: bool,
  maxQuestions: number,
  showLessQuestions: string,
  showMoreQuestions: string
} : void 0;
export default Faq;